export default "__VITE_ASSET__CRml1Xyg__"